








import { Component, Prop, Emit, Vue, Ref } from 'vue-property-decorator';
import { of, throwError, interval, timer, BehaviorSubject, fromEvent } from 'rxjs';
import { switchMap, tap, filter, delay, retry, mergeMap, throttleTime, retryWhen, delayWhen, map, finalize, take, takeUntil } from 'rxjs/operators';
import Frame from './Frame.vue';
import Btn from '@/components/Btn.vue';
import { utilsService } from '@/services/utils.service';
@Component({
  components: { Frame, Btn },
})
export default class Load extends Vue {
  @Prop(Array) list!: Array<string>;

  index: number = 0;
  loadReady: boolean = false;

  loadOb$: BehaviorSubject<any> = new BehaviorSubject(0);
  get progress() {
    return Math.ceil((this.index / this.list.length) * 100);
  }

  @Ref() readonly imgBox!: HTMLElement;

  load: string[] = (n => {
    const arr: string[] = [];
    for (let i = 0; i < n; i++) {
      arr.push(require(`@/assets/images/load/loading/bg${i + 1}.png`));
    }
    return arr;
  })(45);

  @Emit('complete')
  loadOver() {
    console.log('loadOver');
  }

  loadImg() {
    this.list.map(url => {
      const img = new Image();
      img.onload = () => {
        this.loadOb$.next(++this.index);
        this.imgBox.append(img);
      };
      img.src = url;
    });
  }

  start() {
    // console.log(`start`);
    this.loadOver();
    utilsService.gaEvent('loading', 'intro', 'gotofilm');
  }

  created() {
    this.loadImg();

    of(0)
      .pipe(
        switchMap(() => this.loadOb$),
        filter(res => res === this.list.length),
        delay(2000),
        tap(() => (this.loadReady = true)),
      )
      .subscribe();
  }
}
